import React from 'react'
import { useParams } from 'react-router-dom'
import CountryList from '../../components/location/CountryList';
import StateList from '../../components/location/StateList';
import CityList from '../../components/location/CityList';
import PincodeList from '../../components/location/PincodeList';

const Location = () => {
  let { method } = useParams();

  return (
    <>
      {method == "countries" && <CountryList />}
      {method == "states" && <StateList />}
      {method == "cities" && <CityList />}
      {method == "pincode" && <PincodeList />}
    </>
  )
}

export default Location
